import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { FormattedHTMLMessage } from '@bibliocommons/react-intl';

import './LibraryNotice.scss';

const defaultMessage = 'NO MESSAGE';
export function LibraryNotice({ id }) {
  const intl = useIntl();
  const notice = intl.formatMessage({ id, defaultMessage });

  return (
    notice !== defaultMessage && (
      <div className="cp-library-notice">
        <FormattedHTMLMessage id={id} />
      </div>
    )
  );
}

LibraryNotice.propTypes = {
  id: PropTypes.string.isRequired
};

export default LibraryNotice;
